import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SendToMobileIcon(props: IconProps) {
    return <Icon {...props} iconKey={"send_to_mobile"}/>
}
